import { Avatar } from '../../../../../design-system/avatar/avatar/avatar';
import { DrawerClose, DrawerDescription, DrawerHeader, DrawerTitle } from '../../../../../design-system/drawer/drawer';
import { Inline } from '../../../../../design-system/inline/inline';
import { DrawerNavigation } from '../../../../../design-system/navigation/drawer-navigation';
import { Stack } from '../../../../../design-system/stack/stack';
import { TransactionView } from '../../../../../types/entity-types';
import { cn } from '../../../../../utils/cn';
import { navigateToTransaction } from '../utils/navigation';

type HeaderProps = {
  vendor: {
    name: string;
    logo: string;
  };
  amount: string;
  amountWithBaseCurrency: string;
  isCredit: boolean;
  date: string;
  prev?: TransactionView;
  next?: TransactionView;
};

export const Header = ({ vendor, amount, isCredit, amountWithBaseCurrency, date, prev, next }: HeaderProps) => {
  const shouldDisplayBaseCurrencyAmount = amountWithBaseCurrency !== amount;

  const handleNavigatePrev = () => {
    if (prev) {
      navigateToTransaction(prev.id);
    }
  };

  const handleNavigateNext = () => {
    if (next) {
      navigateToTransaction(next.id);
    }
  };

  return (
    <DrawerHeader className="relative flex items-center rounded-lg bg-seapoint-gray-background-modal py-8">
      <Stack className="w-full" space={5} justify="center" align="center">
        <DrawerNavigation
          navigationConfig={{
            isFirstInvoice: !prev,
            isLastInvoice: !next,
            onPrevious: handleNavigatePrev,
            onNext: handleNavigateNext,
          }}
          className="absolute left-3 top-3 bg-white"
        />

        {vendor.name && (
          <Stack align="center" justify="start" space={2}>
            <Avatar name={vendor.name} avatarUrl={vendor.logo} size="lg" />
            <DrawerTitle>
              <div className="text-base font-medium">{vendor.name}</div>
            </DrawerTitle>
          </Stack>
        )}

        <DrawerDescription>
          <Stack space={1} align="center">
            <div
              className={cn('text-center text-[32px] font-thin leading-[40px] tracking-[-0.02em]', {
                'text-seapoint-green': isCredit,
                'text-black': !isCredit,
              })}
            >
              {amount}
            </div>
            <Inline space={2}>
              {shouldDisplayBaseCurrencyAmount && (
                <>
                  <div className="text-sm leading-[22px] text-gray-500">{amountWithBaseCurrency}</div>
                  <div className="text-lg leading-[22px] text-gray-500">·</div>
                </>
              )}
              <div className="text-sm leading-[22px] text-gray-500">{date}</div>
            </Inline>
          </Stack>
        </DrawerDescription>

        <DrawerClose />
      </Stack>
    </DrawerHeader>
  );
};
